import * as React from "react";

interface Tag {
  label: string;
  active: boolean;
}

interface TagFilterProps {
  tags: Tag[];
  onToggleTag: (tag: string) => void;
  onSelectAll: () => void;
}
export const TagFilter = (props: TagFilterProps): JSX.Element => {
  return (
    <div className="my-4 text-break-words">
      <button
        type="button"
        className={`chk-groopit ${
          props.tags.every((t) => t.active) ? "active" : ""
        }`}
        onClick={props.onSelectAll}
      >
        Select All
      </button>
      {props.tags.map((t, i) => (
        <button
          type="button"
          className={`chk-groopit ${t.active ? "active" : ""}`}
          key={i}
          onClick={() => props.onToggleTag(t.label)}
        >
          #{t.label}
        </button>
      ))}
    </div>
  );
};
